<template>
  <div class="profile">
    <p class="profile__title">Профиль</p>

    <div class="profile__content">
      <div class="card">
        <AppAvatar
          :photo="photo"
          style="width: 240px;"
          @delete="onDeletePhoto"
          @file="onNewPhoto"
        />

        <div class="card__info">
          <p class="card__username">{{ username }}</p>
          <p class="card__post">{{ post }}</p>

          <div class="card__other">
            <p class="card-keyval">
              <span class="card-keyval__key">Имя: </span>
              <span class="card-keyval__val">{{ name }}</span>
            </p>
            <p class="card-keyval">
              <span class="card-keyval__key">Телефон: </span>
              <span class="card-keyval__val">{{ phone }}</span>
            </p>
            <div
              class="card__change"
              @click="onOpenPassword"
            >
              Сменить пароль
            </div>
          </div>
        </div>
      </div>

      <div class="profile__block">
        <span @click="onLogout">
          Выйти из аккаунта
        </span>
        <BaseIcon icon="exit" style="width: 22px; margin-left: 10px;" />
      </div>
    </div>

    <AppModal
      ref="password"
      class="change"
    >
      <form
        @submit.prevent="onChangePassword"
      >
        <p class="change__title h3">Смена пароля</p>
        <BaseInput
          v-model="form.oldPassword"
          class="change__input"
          placeholder="Старый пароль"
        />
        <InvalidFeedback v-if="changePasswordVuelidate.oldPassword.required">
          Заполните это поле.
        </InvalidFeedback>
        <InvalidFeedback v-if="changePasswordVuelidate.oldPassword.minLength">
          Пароль не может быть короче 8 символов.
        </InvalidFeedback>

        <BaseInput
          v-model="form.newPassword"
          class="change__input"
          placeholder="Новый пароль"
        />
        <InvalidFeedback v-if="changePasswordVuelidate.newPassword.required">
          Заполните это поле.
        </InvalidFeedback>
        <InvalidFeedback v-if="changePasswordVuelidate.newPassword.minLength">
          Пароль не может быть короче 8 символов.
        </InvalidFeedback>

        <BaseInput
          v-model="form.repeat"
          class="change__input"
          placeholder="Новый пароль"
        />
        <InvalidFeedback v-if="changePasswordVuelidate.repeat.required">
          Заполните это поле.
        </InvalidFeedback>
        <InvalidFeedback v-if="changePasswordVuelidate.repeat.minLength">
          Пароль не может быть короче 8 символов.
        </InvalidFeedback>
        <InvalidFeedback v-if="changePasswordVuelidate.repeat.sameAsNewPassword">
          Пароли не совпадают
        </InvalidFeedback>

        <div class="change__btn-container">
          <BaseButton
            class="change__btn"
            type="submit"
          >
            СОХРАНИТЬ
          </BaseButton>
          <BaseButton
            class="change__btn"
            theme="simple"
            type="reset"
            @click="onClosePassword"
          >
            Отмена
          </BaseButton>
        </div>
        <InvalidFeedback v-if="error" style="text-align: center; margin-top: 22px;">
          {{ error }}
        </InvalidFeedback>
      </form>
    </AppModal>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, minLength, sameAs } from '@vuelidate/validators'

import AppAvatar from '@/components/AppAvatar'
import BaseIcon from '@/components/Base/BaseIcon'
import AppModal from '@/components/AppModal'
import BaseInput from '@/components/Base/BaseInput'
import BaseButton from '@/components/Base/BaseButton'
import InvalidFeedback from '@/components/InvalidFeedback'

export default {
  name: 'profile',
  components: {
    AppAvatar,
    InvalidFeedback,
    BaseButton,
    BaseInput,
    AppModal,
    BaseIcon
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data () {
    return {
      photo: '',
      username: '',
      post: '',
      name: '',
      phone: '',
      form: {
        oldPassword: '',
        newPassword: '',
        repeat: ''
      },
      error: ''
    }
  },
  computed: {
    changePasswordVuelidate () {
      const dirty = this.v$.form.$dirty

      return {
        oldPassword: {
          required: dirty && this.v$.form.oldPassword.required.$invalid,
          minLength: dirty && this.v$.form.oldPassword.minLength.$invalid
        },
        newPassword: {
          required: dirty && this.v$.form.newPassword.required.$invalid,
          minLength: dirty && this.v$.form.newPassword.minLength.$invalid
        },
        repeat: {
          required: dirty && this.v$.form.repeat.required.$invalid,
          minLength: dirty && this.v$.form.repeat.minLength.$invalid,
          sameAsNewPassword: dirty && this.v$.form.repeat.sameAsNewPassword.$invalid
        }
      }
    }
  },
  async created () {
    await this.fetchProfile()
  },
  methods: {
    async fetchProfile () {
      try {
        const { data } = await this.$api.profile.me()
        this.photo = data?.photo?.url ?? ''
        this.username = data.username ?? ''
        this.post = data.roleLabel ?? ''
        this.name = data.name ?? ''
        this.phone = data.phone ?? ''
      } catch (e) {
        console.log(e)
      }
    },
    onLogout () {
      this.$store.dispatch('auth/logout')
    },
    onOpenPassword () {
      this.$refs.password.open()
    },
    onClosePassword () {
      this.$refs.password.close()
    },
    async onChangePassword () {
      if (this.v$.form.$invalid) {
        this.v$.form.$touch()
        return
      }

      try {
        this.error = ''
        const { data } = await this.$api.auth.change({
          password: this.form.oldPassword,
          newPassword: this.form.newPassword
        })

        if (data.status === 'ok') {
          this.onClosePassword()
          this.form.oldPassword = ''
          this.form.newPassword = ''
          this.form.repeat = ''

          setImmediate(() => {
            alert('Пароль был изменен.')
          })
        } else {
          this.error = data.message
        }
      } catch (e) {
        console.log(e)
      }
    },
    async onDeletePhoto () {
      try {
        await this.$api.profile.deletePhoto()
        await this.$store.dispatch('auth/fetchUser')
        this.photo = ''
      } catch (e) {
        alert('Произошла ошибка при попытке удаления фотографии.')
        console.log(e)
      }
    },
    async onNewPhoto (photo) {
      try {
        const base64 = await this.getBase64(photo)
        await this.$api.profile.uploadAvatar(base64)
        await this.$store.dispatch('auth/fetchUser')
        this.photo = base64
      } catch (e) {
        console.log(e)
      }
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    }
  },
  validations () {
    return {
      form: {
        oldPassword: {
          required,
          minLength: minLength(8)
        },
        newPassword: {
          required,
          minLength: minLength(8)
        },
        repeat: {
          required,
          minLength: minLength(8),
          sameAsNewPassword: sameAs(this.form.newPassword)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.profile {
  &__title {
    font-size: 24px;
    color: #E0E0EB;
  }

  &__content {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &__block {
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .card {
    display: flex;

    &__info {
      margin-left: 20px;
    }

    &__username {
      font-weight: bold;
      font-size: 28px;
      color: #FFFFFF;
    }
    &__post {
      font-size: 16px;
      line-height: 20px;
      color: #C6C6CE;
      margin-top: 10px;
    }

    &__other {
      margin-top: 40px;
    }

    .card-keyval {
      font-size: 16px;
      margin-bottom: 8px;
      font-weight: bold;

      //&:not(:last-child) {}

      &__key {
        color: #9A9AA2;
      }
      &__val {
        color: #fff;
      }
    }

    &__change {
      color: $brand-color;
      text-decoration: none;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.change {
  &__title {
    text-align: center;
  }

  &__input {
    margin-top: 14px;
    height: 60px;
    background: #323235;
  }

  &__btn-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 14px;
  }

  &__btn {
    width: 49%;
    height: 50px;
  }
}
</style>
